export default __webpack_public_path__ + "static/floatingImg4-c6b529f8a500462812fb6182e620cbf1.webp";